import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonModule as NimbusCommonModule } from '../../common/common.module';
import { FolderComponent } from './folder.component';
import { ItemNoteListComponent } from './item-note-list.component';
import { ItemFolderListComponent } from './item-folder-list.component';
import { ItemNoteComponent } from './item-note.component';
import { ItemFolderComponent } from './item-folder.component';
import { MasonryComponent } from './masonry.component';
import { MasonryBrickComponent } from './masonry-brick.component';
import { ShowMoreComponent } from './show-more.component';
import { FolderEmptyComponent } from './folder-empty.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    RouterModule
  ],
  declarations: [
    FolderComponent,
    ItemNoteListComponent,
    ItemFolderListComponent,
    ItemNoteComponent,
    ItemFolderComponent,
    MasonryComponent,
    MasonryBrickComponent,
    ShowMoreComponent,
    FolderEmptyComponent
  ],
  exports: [
    FolderComponent
  ],
  providers: []
})
export class FolderModule { }
